<div
  *ngIf="!showMatTooltip"
  class="display-flex align-items-center custom-tooltip-bottom"
  [attr.data-tooltip]="!disableTooltip ? customTooltip || (!showFullName ? fullName : null) : null">
  <ng-container *ngIf="showIcon" [ngTemplateOutlet]="iconBox"></ng-container>
  <ng-container *ngIf="showFullName" [ngTemplateOutlet]="fullNameTemplate"></ng-container>
</div>

<div
  *ngIf="showMatTooltip"
  class="display-flex align-items-center"
  [matTooltip]="!disableTooltip ? customTooltip || (!showFullName ? fullName : null) : null">
  <ng-container *ngIf="showIcon" [ngTemplateOutlet]="iconBox"></ng-container>
  <ng-container *ngIf="showFullName" [ngTemplateOutlet]="fullNameTemplate"></ng-container>
</div>

<ng-template #iconBox>
  <div class="avatar display-flex justify-content-center align-items-center" [ngClass]="[containerCss, avatarTheme]">
    <ng-container *ngIf="firstName || lastName" [ngTemplateOutlet]="nameTemplate"></ng-container>
    <ng-container *ngIf="icon" [ngTemplateOutlet]="iconTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #nameTemplate>
  <div>{{ firstName | formatToAvatar: lastName:isUpperCase }}</div>
</ng-template>

<ng-template #iconTemplate>
  <app-icon [svg]="icon" [iconWidth]="iconSize" [iconHeight]="iconSize"></app-icon>
</ng-template>

<ng-template #fullNameTemplate>
  <div class="body-small">{{ fullName }}</div>
</ng-template>
